import React from "react";
import Table from "../../../../components/tables/Table";
import { ICarrierMetricsPerState } from "../types";

interface ICarrierMetricsPerStatePros {
  data?: ICarrierMetricsPerState[];
}
const CarrierMetricPerStateTable = ({ data }: ICarrierMetricsPerStatePros) => {
  const columns = [
    {
      name: "State",
      cell: (row) => row.state,
      sortable: true,
    },
    {
      name: "Total PIF Count",
      cell: (row) => row.totalPIFCount,
      sortable: true,
    },
    {
      name: "Total PIF Premium",
      cell: (row) => row.totalPIFPremium,
      sortable: true,
    },
    {
      name: "New Business Premium",
      cell: (row) => row.newBusinessPremium,
      sortable: true,
    },
    {
      name: "Renewal Premium",
      cell: (row) => row.renewalPremium,
      sortable: true,
    },
  ];

  return (
    <div className="space-y-5">
      <Table
        columns={columns}
        data={data}
        loading={false}
        selectableRows={false}
        expandableRowsComponent={undefined}
        onSelectedRowsChange={undefined}
        clearSelectedRows={undefined}
        setOpenModal={undefined}
        expandableRowExpanded={undefined}
      />
    </div>
  );
};

export default CarrierMetricPerStateTable;
